import ReactModal from "react-modal";
import {AboutTheDataApiContents} from "../pages/datasetpage.js";

/**
 * Modal dialog that displays API instructions for a given dataset.
 *
 * @param props.apidDataset Response from backend describing dataset.
 * @param prop.isApiModalOpen Whether to display the modal
 * @param props.setApiModalOpen Sets the value of isApiModalOpen
 * @return JSX
 */
export function ApiInstructionsModal(props) {
    const {apiDataset, isApiModalOpen, setApiModalOpen} = props;
    const modalStyle = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.75)'
        },
        content: {
            position: 'absolute',
            top: '10%',
            left: '20%',
            right: '20%',
            bottom: '20%',
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
            padding: '20px'
        }
    };

    const onRequestClose = () => {
        setApiModalOpen(false);
    };

    return (
        <ReactModal
          style={modalStyle}
          isOpen={isApiModalOpen}
          onRequestClose={onRequestClose}>
          <AboutTheDataApiContents datasetData={apiDataset} />
          <div>
            <br />
            <button onClick={onRequestClose} className="apiInstructionBlueButton">
                Close
            </button>
            <br />
          </div>
        </ReactModal>
    );
}



